__turbopack_context__.v({
  "terms": "terms-module-scss-module__ywNSAa__terms",
  "visuallyHidden": "terms-module-scss-module__ywNSAa__visuallyHidden",
});
